let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gB2Tu")).then(() => parcelRequire('dDf59'));